export default "__VITE_ASSET__0GCvsLBC__"